import { Component, OnInit } from "@angular/core";
import { DestinatarioInternoVO } from "@app/shared/vo/gescor/destinatario-internoVO";
import { ContattoVO } from "@app/shared/vo/contattoVO";
import { StrutturaVO } from "@app/shared/vo/strutturaVO";
import { OrganoService } from "@app/shared/services/organo.service";
import { ControlContainer, FormBuilder, FormArray } from "@angular/forms";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";

@Component({
  selector: "app-tab-destinatari-interni",
  templateUrl: "./tab-destinatari-interni.component.html",
})
export class TabDestinatariInterniComponent implements OnInit {
  public tabDestinatariInterni;
  messagesDest = {
    emptyMessage: "Nessun soggetto trovato",
    totalMessage: "in totale",
  };
  listaInterniDiretti: ContattoVO[] = new Array<ContattoVO>();
  listaInterniConoscenza: ContattoVO[] = new Array<ContattoVO>();
  public settore: string;
  public isCollapsedTableContent: boolean = false;
  public rowsStrutture = new Array<StrutturaVO>();
  public loadingIndicator: boolean = false;
  settoreSearch: any;
  destinatariInterni: DestinatarioInternoVO[] = new Array<
    DestinatarioInternoVO
  >();

  constructor(
    private organoService: OrganoService,
    private fb: FormBuilder,
    private parentControl: ControlContainer
  ) { }

  ngOnInit() {
    this.tabDestinatariInterni = this.parentControl.control.get(
      "formDestinatariInterni"
    );
    console.log("this.tabDestinatariInterni", this.tabDestinatariInterni);
  }

  public cercaSettore() {
    //   this.selectedInterni = [];
    this.loadingIndicator = true;
    this.settoreSearch = this.parentControl.control.get(
      "formDestinatariInterni.settoreSearch"
    ).value;
    this.rowsStrutture = new Array<StrutturaVO>();
    console.log("cercaSettore: ", this.settoreSearch);

    this.organoService.getCMU(this.settoreSearch).subscribe(
      (res) => {
        console.log("res: ", res);
        this.rowsStrutture = res.filter((entry) => entry.tipo !== "LISTA");
        this.loadingIndicator = false;
      },
      (_) => (this.loadingIndicator = false)
    );
  }

  public onSelectInterni(strutturaVO: StrutturaVO, tipo: string) {
    const destInterniArray = this.tabDestinatariInterni.controls[
      "destinatariInterni"
    ] as FormArray;
    if (
      this.destinatariInterni
        .map(function (e) {
          return e.idCmu;
        })
        .indexOf(strutturaVO.id) < 0
    ) {
      const destinarioInternoVO = new DestinatarioInternoVO();
      destinarioInternoVO.idCmu = strutturaVO.id;
      destinarioInternoVO.nomeCmu = strutturaVO.nome;
      destinarioInternoVO.responsabile = strutturaVO.responsabile;
      if (tipo === "DIRETTO") {
        destinarioInternoVO.tipoDestinatario = TipoDestinatarioEnum.DIRETTO;
      } else {
        destinarioInternoVO.tipoDestinatario =
          TipoDestinatarioEnum.PER_CONOSCENZA;
      }
      const destinatarioInterno = this.fb.group({
        tipoDestinatario: [destinarioInternoVO.tipoDestinatario],
        idCmu: [destinarioInternoVO.idCmu],
        nomeCmu: [destinarioInternoVO.nomeCmu],
        responsabile: [destinarioInternoVO.responsabile],
      });
      destInterniArray.push(destinatarioInterno);
      this.creaContatto(destinarioInternoVO);
      this.destinatariInterni.push(destinarioInternoVO); //
    }
  }

  public spostaAltroLivello(internoDaSpostare: ContattoVO[], tipo: string) {
    let listaDestInterniPartenza = new Array<ContattoVO>();
    let listaDestInterniArrivo = new Array<ContattoVO>();
    let nuovoLivello: TipoDestinatarioEnum;

    if (tipo === "DIRETTO") {
      nuovoLivello = TipoDestinatarioEnum.PER_CONOSCENZA;
      listaDestInterniPartenza = this.listaInterniDiretti;
      listaDestInterniArrivo = this.listaInterniConoscenza;
      internoDaSpostare[0].indirizzo = "PER_CONOSCENZA";
    } else {
      nuovoLivello = TipoDestinatarioEnum.DIRETTO;
      listaDestInterniPartenza = this.listaInterniConoscenza;
      listaDestInterniArrivo = this.listaInterniDiretti;
      internoDaSpostare[0].indirizzo = "DIRETTO";
    }

    listaDestInterniPartenza = listaDestInterniPartenza.filter(
      (item) => item.idSoggetto !== internoDaSpostare[0].idSoggetto
    );

    listaDestInterniArrivo.push(internoDaSpostare[0]);

    if (tipo === "DIRETTO") {
      this.listaInterniDiretti = listaDestInterniPartenza;
      this.listaInterniConoscenza = listaDestInterniArrivo;
    } else {
      this.listaInterniConoscenza = listaDestInterniPartenza;
      this.listaInterniDiretti = listaDestInterniArrivo;
    }

    const destArray = this.tabDestinatariInterni.controls[
      "destinatariInterni"
    ] as FormArray;
    let indiceDaAgg: number;
    for (let i = 0; i < destArray.length; i++) {
      if (destArray.at(i).value.idCmu === internoDaSpostare[0].idSoggetto) {
        indiceDaAgg = i;
      }
    }
    let internoDaAggiornare = new DestinatarioInternoVO();
    internoDaAggiornare = destArray.at(indiceDaAgg).value;
    internoDaAggiornare.tipoDestinatario = nuovoLivello;

    destArray.at(indiceDaAgg).patchValue(internoDaAggiornare);
  }

  creaContatto(destinatarioInternoVO: DestinatarioInternoVO) {
    const contattoVO = new ContattoVO();
    if (
      destinatarioInternoVO.tipoDestinatario === TipoDestinatarioEnum.DIRETTO
    ) {
      contattoVO.nome = destinatarioInternoVO.nomeCmu;
      contattoVO.idSoggetto = destinatarioInternoVO.idCmu;
      contattoVO.indirizzo = TipoDestinatarioEnum.DIRETTO.toString();
      contattoVO.immagine = "./assets/img/soggstran.png";
      this.listaInterniDiretti.push(contattoVO);
    } else {
      contattoVO.nome = destinatarioInternoVO.nomeCmu;
      contattoVO.idSoggetto = destinatarioInternoVO.idCmu;
      contattoVO.indirizzo = TipoDestinatarioEnum.PER_CONOSCENZA.toString();
      contattoVO.immagine = "./assets/img/sogg.png";
      this.listaInterniConoscenza.push(contattoVO);
    }
  }

  public aggiornaDopoRimozione(listaInterniNew: ContattoVO[], tipo: string) {
    let listaInterniOld = new Array<ContattoVO>();
    if (tipo === "DIRETTO") {
      listaInterniOld = this.listaInterniDiretti;
    } else {
      listaInterniOld = this.listaInterniConoscenza;
    }

    const missingInterno = listaInterniOld.filter(
      (item) => listaInterniNew.indexOf(item) < 0
    );

    if (missingInterno.length > 0) {
      listaInterniOld = listaInterniOld.filter(
        (item) => missingInterno[0].idSoggetto !== item.idSoggetto
      );
      this.destinatariInterni = this.destinatariInterni.filter(
        (item) => missingInterno[0].idSoggetto !== item.idCmu
      );
    }
    if (tipo === "DIRETTO") {
      this.listaInterniDiretti = listaInterniNew;
    } else {
      this.listaInterniConoscenza = listaInterniNew;
    }

    const destArray = this.tabDestinatariInterni.controls[
      "destinatariInterni"
    ] as FormArray;
    destArray.removeAt(
      destArray.value.findIndex(
        (interno) => interno.idCmu === missingInterno[0].idSoggetto
      )
    );
  }
}
